// Models
// Utilities
import { convertPerformanceMarkerTagToString } from "../utilities/PerformanceUtilities";
import { recordPerfInsight } from "./PerfInsightsSink";
/**
 * Web platform performance marker
 */ export class WebPlatformPerformanceMarker {
    mark(tag, extraData) {
        const extraDataWithTimestamp = {
            ...extraData || {},
            timestamp: Date.now().toString()
        };
        const markTag = convertPerformanceMarkerTagToString(tag, extraDataWithTimestamp);
        performance.mark(markTag);
        // Mirror to the dev tools Perf Insights panel. Does nothing unless dev tools enabled it.
        recordPerfInsight(tag, extraDataWithTimestamp);
    }
}
